import React from "react";
import { WEBXR_SUPPORT_STATUS } from "./webxrSupport.mjs";

const UNSUPPORTED_MESSAGE =
  "VR mode requires Meta Quest Browser or another WebXR-compatible browser.";

export default function WebXREntry({
  support,
  isReady,
  isEntering,
  isPresenting,
  errorMessage,
  statusMessage,
  buildId,
  onEnterVR,
}) {
  const status = support?.status ?? WEBXR_SUPPORT_STATUS.webxrUnavailable;
  const canEnterVR = status === WEBXR_SUPPORT_STATUS.supportedInCurrentBrowser;
  const canSendToQuest = status === WEBXR_SUPPORT_STATUS.canShowSendToQuest &&
    support?.questLaunchUrl;
  const buttonText = isPresenting
    ? "VR active"
    : isEntering
      ? "Preparing VR"
      : "Enter VR";

  return (
    <section className="panel xr-panel" aria-live="polite">
      <div className="panel-heading">
        <span className="panel-label">WebXR</span>
        <span className="panel-chip">Optional</span>
      </div>

      <div className="xr-actions">
        {canEnterVR ? (
          <button
            type="button"
            className="mode-toggle__button xr-action-button"
            onClick={onEnterVR}
            disabled={!isReady || isEntering || isPresenting}
          >
            {buttonText}
          </button>
        ) : null}

        {canSendToQuest ? (
          <a
            className="mode-toggle__button xr-action-button"
            href={support.questLaunchUrl}
            target="_blank"
            rel="noreferrer"
          >
            Open on Meta Quest
          </a>
        ) : null}

        {!canEnterVR && !canSendToQuest ? (
          <button
            type="button"
            className="mode-toggle__button xr-action-button"
            disabled
            title={UNSUPPORTED_MESSAGE}
          >
            Enter VR
          </button>
        ) : null}
      </div>

      <p className="xr-help-text">
        Use Meta Quest Browser and select Enter VR. Compatible with Meta Quest 2 or newer.
      </p>

      <p className="xr-status-text">
        Build {buildId} / {statusMessage || "Idle"}
      </p>

      {status === WEBXR_SUPPORT_STATUS.likelyQuestBrowser && !canEnterVR ? (
        <p className="xr-status-text">{UNSUPPORTED_MESSAGE}</p>
      ) : null}

      {status === WEBXR_SUPPORT_STATUS.webxrUnavailable ? (
        <p className="xr-status-text">{UNSUPPORTED_MESSAGE}</p>
      ) : null}

      {errorMessage ? (
        <p className="xr-status-text xr-status-text--error">{errorMessage}</p>
      ) : null}
    </section>
  );
}
